import { addContentPath } from '../../../util/pathUtil';

// 登录按钮默认数据
const loginButtonDef = {
    showtype: 'loginButton',
    isLock: true,
    color: '#bacde0', // 文字颜色
    fsize: 18,
    backgroundColor: '#0b1a32', // 按钮背景色
    isAbsolute: 0, // 位置
    level: 'center', // 水平
    vertical: 'middle', // 垂直
    levelMargin: 0, // 水平边距
    verticalMargin: 233, // 垂直边距
    x: 0,
    y: 0,
    rate_x: 0,
    rate_y: 0,
    width: 324,
    height: 45,
    // 按钮宽高
    original_width: 324,
    original_height: 45,
    opacity: 100,
    borderR: 0,
    // button type : button/image
    imgbtn: false,
    isShowtext: true,
    imgWidth: 324,
    imgHeight: 45,
    content: addContentPath('/images/loginbtn.png'),
    imgopacity: 100,
    imgColor: '#bacde0', // 文字颜色
    imgFsize: 18,
    isloginbtn: true,
};
export { loginButtonDef };



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/e9login/loginButton.js